<template>
  <div class="card">
    <div id="toolbar" class="fixed-table-toolbar">
      <div class="float-left">
        <h2 style="padding-left: 10px; padding-top: 10px; padding-bottom: 0px;"> <span class="icon-list"></span>   Cateogry's List</h2>
      </div>
      <div class="float-right search">
        <input  id="txtsearch" class="form-control" type="text" placeholder="Search" autocomplete="off">
      </div>
    </div>

    <div class="table-responsive">
      <table id="mytable"
             class="table table-borderless table-condensed"
             data-search="false"
             data-pagination="true"
             data-show-refresh="false"
             data-show-columns="false"
             data-page-list="[10, 25, 50, 100, ALL]"
             data-show-footer="false"
             data-toggle="context"
             data-target=".context-table">
        <thead>
          <tr>
            <th data-field="id" data-class="d-none">id</th>
            <th data-field="code" data-width="100" >Code</th>
            <th data-field="name" >Name</th>
          </tr>
        </thead>
        <tbody>
        </tbody>
        <tfoot>
        </tfoot>
      </table>
    </div>

    <!-- Context Menu -->
    <div id="context-menu" class="context-table">
      <div class="dropdown-menu">
        <a href="#" class="dropdown-item" @click="loadData"><i class="icon-reset" style="color: darkgreen"></i>Refresh</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item"> <i class="icon-pencil3" ></i>Modify</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item"> <i class="icon-blocked" style="color: red" ></i>Remove</a>
      </div>
    </div>
    <!-- End of Context Menu -->

    <!-- Clickable menu -->
    <ul class="fab-menu fab-menu-fixed fab-menu-bottom-right is_stuck" data-fab-toggle="hover" z-index="0">
      <li>
        <a class="fab-menu-btn btn bg-primary-600 btn-float rounded-round btn-icon" @click="showModal">
          <i class="fab-icon-open icon-plus3"></i>
          <i class="fab-icon-close icon-plus3"></i>
        </a>
      </li>
    </ul>
    <!-- /clickable menu -->

    <vmodal name="cateogry-window" transition="nice-modal-fade" :delay="100" :resizable="true" :width="550" height="40%" >

      <div class="card-header header-elements-inline" >
        <h5 class="card-title">Category Creation</h5>
        <div class="header-elements">
          <div class="list-icons">
            <!--<a class="list-icons-item" data-action="reload"></a>-->
            <a class="list-icons-item" data-action="remove" @click="closeModal"></a>
          </div>
        </div>
      </div>

      <div class="card-body">
        <form action="#">

          <div class="form-group row">
            <label class="col-lg-2 col-form-label">Name:</label>
            <div class="col-lg-10">
              <input type="text" class="form-control" placeholder="Enter Category Name here..." maxlength="100" v-if="category" v-model="category.name">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 col-form-label">Print Name:</label>
            <div class="col-lg-10">
              <input type="text" class="form-control" placeholder="Enter your print name here..." maxlength="100" v-if="category" v-model="category.p_name">
            </div>
          </div>

        </form>
      </div>

      <div class="card-footer">
        <div class="text-right" >
          <button type="button" class="btn btn-primary" @click="save" >Save<i class="icon-paperplane ml-2"></i></button>
        </div>
      </div>

    </vmodal>

  </div>

</template>

<script>
  import CateogryForm from '@/components/v1/category/CategoryForm.vue'
  import moment from 'moment-timezone'
  import {userService} from '@/store/auth-header.js'
  export default {
    name: 'CateogryView',
    components: {
      CateogryForm
    },
    data () {
      return {
        mytable: {},
        category: JSON.parse('{"id":"","code":0,"name":"","p_name":""}')
      }
    },
    created () {

    },
    mounted () {
      let self = this;

      this.$data.mytable = $('#mytable');

      this.$data.mytable.bootstrapTable();
      $('[data-toggle="popover"]').popover();

      $('#mytable').contextmenu({
        target: '#context-menu',
        scopes: 'tbody > tr',
        onItem: function (row, e) {
          var id = $(row.children('*')[0]).text();

          if ($(e.target).text() === 'Modify') {
            self.modifyDocument (id);
          } else if ($(e.target).text() === 'Remove') {
            self.removeDocument(id);
          }
        }
      });

      $('#txtsearch').keyup(function () {
        var val = $.trim($(this).val()).replace(/ +/g, ' ').toLowerCase()
        $('#fcc-table>tbody>tr').show().filter(function () {
          var text = $(this).text().replace(/\s+/g, ' ').toLowerCase()
          return !~text.indexOf(val)
        }).hide()
      });

      self.loadData();
    },
    methods: {
      closeModal() {
        this.$modal.hide('cateogry-window');
      },
      showModal () {
        this.$modal.show('cateogry-window');
      },
      loadData () {
        let self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        self.$data.mytable.bootstrapTable('load',[]);

        fetch(`${process.env.VUE_APP_ROOT_API}v1/tms/category/`,requestOptions).then(userService.handleResponse).then(function (data) {
          if(data.accepted) {
            self.$data.mytable.bootstrapTable('load', data.data);
          } else {
            swal ( { title: "Oh noes!" ,  text: data.message, icon:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), icon:  "error"} );
        });
      },
      clear(){
        this.group= JSON.parse('{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"subunit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":1,"has_bom":false,"sys_obj":false}');
      },
      modifyDocument (id) {
        let self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        self.$data.category = JSON.parse('{"id":"","code":0,"name":"","p_name":""}');

        fetch(`${process.env.VUE_APP_ROOT_API}v1/tms/category/${id}/`,requestOptions).then(userService.handleResponse).then(function (data) {
          if(data.accepted) {
            self.$data.category = data.data;
            self.$modal.show('cateogry-window');
          } else {
            swal ( { title: "Oh noes!" ,  text: data.message, icon:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text:  err.toString() , icon:  "error"} );
        });
      },
      removeDocument (id) {
        let self = this;

        self.$data.category.id = id;

        const requestOptions = {
          method: 'DELETE',
          mode:'cors',
          headers: userService.authHeader(),
          body: JSON.stringify(self.$data.category)
        };

        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          timer: 3000,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete tms!'
        }).then((result) => {
          if (result.value) {
            fetch(`${process.env.VUE_APP_ROOT_API}v1/tms/category/${id}`,requestOptions).then(userService.handleResponse).then(function (resp) {
              self.$modal.hide('category_window')
              self.loadData();
              swal(
                'Deleted!',
                'Your request has been processed',
                'success'
              );
            }).catch(function (err) {
              swal({ title: "Oops", text: err.toString(), type: "error" });
            });
          }
        });
      },
      saveDocument () {

        let self = this;

        if(self.$data.category.name.trim().length < 1){
          alert("Invalid Name");
          return
        }

        const requestOptions = {
          method:  (self.$data.category.code == 0 ? 'POST' : 'PUT'),
          mode:"cors",
          headers: userService.authHeader(),
          body: JSON.stringify(self.$data.category)
        };

        fetch(`${process.env.VUE_APP_ROOT_API}v1/tms/category/`,requestOptions).then(userService.handleResponse).then(function (data) {
          if(data.accepted) {
            swal ( { title: "Success!" ,  text: data.message, icon:  "success"} );
            self.category = JSON.parse('{"id":"","code":0,"name":"","p_name":""}');
            self.closeModal();
          } else {
            swal ( { title: "Oh noes!" ,  text: data.message, icon:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), icon:  "error"} );
        });
      }
    }
  }
</script>

<style scoped>
  .modal {
    text-align: center;
    padding: 0!important;
  }

  .modal:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  .modal-dialog {
    display: inline-block;
    text-align: left;
    width: 40%;
    vertical-align: middle;
  }
</style>
